import logo from './logo.svg';
import './styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import About from './pages/About.js';
import Contact from './pages/Contact.js';
import Products from './pages/Products.js';
import Services from './pages/Services.js';
import NavBar from './components/NavBar.js';
import LandingPage from './pages/LandingPage.js';
import ProductPage from './components/ProductPage.js';
import ProductExplorer from './pages/ProductExplorer.js';
import Distributors from './pages/Distributors.js';

function App() {
  return (
    <div className="App">
      <Router>
        <NavBar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<ProductExplorer />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products/aurora-end-suction" element={<ProductPage />}/>
        <Route path="/distributors" element={<Distributors/>}/>
      </Routes>
    </Router>
    </div>
  );
}

export default App;
